import { useState } from "react";
import { fetchEIdAuthenticationStatusSeBankId } from "Shared/util/web-api";
import {
    EIdAuthenticationStatus,
    EIdAuthenticationStatusResource,
} from "Shared/util/types";

export const useSeBankIdPoller = (
    registerPromise: (p: Promise<any>) => Promise<any>,
    onAuthenticationSucceeded: (token: string) => void,
    onAuthenticationFailed: () => void,
    onAuthenticationError: () => void,
) => {
    const [pollingEIdStatusTimeoutId, setPollingEIdStatusTimeoutId] = useState<
        number | undefined
    >(undefined);

    const stopPolling = () => {
        if (pollingEIdStatusTimeoutId !== undefined) {
            clearTimeout(pollingEIdStatusTimeoutId);
            setPollingEIdStatusTimeoutId(undefined);
        }
        setPollingEIdStatusTimeoutId(undefined);
    };

    const executePoll = (
        token: string,
        onQrCodeImageUpdated: (qrCodeImage: string) => void,
    ) => {
        registerPromise(fetchEIdAuthenticationStatusSeBankId(token))
            .then((result: EIdAuthenticationStatusResource) => {
                const { qrCodeImage, status, verificationToken } = result;
                switch (status) {
                    case EIdAuthenticationStatus.Pending: {
                        onQrCodeImageUpdated(qrCodeImage);
                        const timeoutId: any = setTimeout(
                            () => executePoll(token, onQrCodeImageUpdated),
                            900,
                        );
                        setPollingEIdStatusTimeoutId(timeoutId);
                        break;
                    }
                    case EIdAuthenticationStatus.Completed: {
                        if (verificationToken) {
                            stopPolling();
                            onAuthenticationSucceeded(verificationToken);
                        }
                        break;
                    }
                    case EIdAuthenticationStatus.Failed: {
                        onAuthenticationFailed();
                        break;
                    }
                    default: {
                        onAuthenticationError();
                        break;
                    }
                }
            })
            .catch(() => onAuthenticationError());
    };

    return {
        start: executePoll,
        stop: stopPolling,
    };
};
